// extracted by mini-css-extract-plugin
module.exports = {"cardCol":"CrossSegmentCard-CardCol-module--card-col--uYiEQ"};